import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { renderHtmlFromEditorJS } from '../../core/utils/utils';

const StudioTemplateMixin = Vue.extend({
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    hasWelcomeVideo() {
      return this.studio?.welcome_video;
    },
    headerImage() {
      return this.studio?.cover_photo;
    },
    profilePhoto() {
      return this.studio?.profile_photo?.thumbnail;
    },
    sortedProducts() {
      if (!this.studio || !this.studio.products) return [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.studio.products.sort((p1, p2) => p1.position - p2.position);
    },
    getFirstProduct() {
      return this.sortedProducts[0];
    },
    getHomepageProducts() {
      const numberOfFeaturedProducts = this.getFirstProduct ? 1 : 0;
      const totalHomepageProducts = Math.min(
        3 - numberOfFeaturedProducts,
        this.studio.products.length
      );
      return (
        this.sortedProducts
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .filter(product => {
            // exclude any products not suitable for being displayed on the home page
            return true;
          })
          .splice(numberOfFeaturedProducts, totalHomepageProducts)
      );
    },
    getShopPreviewProducts() {
      const totalHomepageProducts = 4;
      return (
        this.sortedProducts
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .filter(product => {
            // exclude any products not suitable for being displayed on the home page
            return true;
          })
          .slice(0, totalHomepageProducts)
      );
    },
  },
  methods: {
    renderHtmlFromEditorJS: renderHtmlFromEditorJS,
    goToShop() {
      this.$router.push({ name: 'studio-shop' });
    },
    studioDescriptionExists(description, descriptionNew) {
      let newObject = {};
      if (descriptionNew && descriptionNew.length) {
        newObject = JSON.parse(descriptionNew);
      }
      return !descriptionNew ? !!description : newObject.blocks?.length;
    },
  },
});

export default StudioTemplateMixin;
